import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import Cookies from "js-cookie";

const Logout = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const signOut = async () => {
      try {
        // Notificar a otras pestañas que se está cerrando sesión con flags duraderos
        const logoutTime = Date.now();
        localStorage.setItem('logout_event', logoutTime.toString());
        localStorage.setItem('force_logout', 'true');

        // Limpiar todas las cookies
        Cookies.remove("token");
        Cookies.remove("token", { path: "/" });
        Cookies.remove("token", { domain: window.location.hostname, path: "/" });
        Cookies.remove("nombres");
        Cookies.remove("apellidos");
        Cookies.remove("identificacion");
        Cookies.remove("cas");
        Cookies.remove("rol");
        Cookies.remove("username");
        Cookies.remove("DatosPersonalesGIA.CAS");
        Cookies.remove("id");
        Cookies.remove("correoAlterno");
        Cookies.remove("Nombre");

        // Limpiar completamente el sessionStorage
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("user_data");
        sessionStorage.removeItem("nombres");
        sessionStorage.removeItem("apellidos");
        sessionStorage.removeItem("entra_login_done"); // Limpiar flag de Azure AD
        sessionStorage.clear();

        // Limpiar los eventos después de 30 segundos
        setTimeout(() => {
          localStorage.removeItem('logout_event');
          localStorage.removeItem('force_logout');
        }, 30000);

        // Cerrar sesión de Azure AD y redirigir
        await instance.logoutRedirect({
          postLogoutRedirectUri: "/inicio", // Redirige al home después del logout
        });
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
      }
    };

    signOut();
  }, [instance]);

  return null; // No muestra nada, redirige automáticamente
};

export default Logout;
